import { defineComponent as _defineComponent } from 'vue'
import { CallModel, CallStatus, CallType, Permission } from '@/types';
import { formatDateAsString, formatSecToTime } from '@/utils/datetime';
import { CalendarIcon, ClockIcon, PlayIcon, UserIcon } from '@heroicons/vue/solid';
import { computed, PropType } from 'vue';
import moment from 'moment';
import { ContactSentiment, contactSentimentMap } from '@/utils/contactSentiment';


export default /*@__PURE__*/_defineComponent({
  __name: 'ContactTimelineCallDetails',
  props: {
    call: {
        type: Object as PropType<CallModel>,
        required: true,
    },
    showViewButton: {
        type: Boolean,
        default: true,
    },
},
  setup(__props, { expose: __expose }) {
  __expose();

const props = __props;

const duration = computed(() => {
    return moment(props.call?.endedAt).diff(moment(props.call.answeredAt), 'seconds');
});

const sourceEvent = computed(() => (props.call.events?.length ? props.call.events[0] : null));

const destinationEvent = computed(() => {
    const events = props.call.events ?? [];
    if (!events.length) return null;

    if (props.call.type === CallType.INBOUND && props.call.status === CallStatus.ANSWERED) {
        return events.find((event) => event.status === props.call.status) ?? null;
    } else if (props.call.type === CallType.OUTBOUND) {
        return events[0];
    }
    return events[events.length - 1];
});

const sentiment = computed(() => {
    const value = props.call.speechMetrics?.clientSentimentEnd;
    return value && Object.hasOwn(contactSentimentMap, value)
        ? contactSentimentMap[value as ContactSentiment]
        : contactSentimentMap.unidentified;
});

const __returned__ = { props, duration, sourceEvent, destinationEvent, sentiment, get CallStatus() { return CallStatus }, get Permission() { return Permission }, get formatDateAsString() { return formatDateAsString }, get formatSecToTime() { return formatSecToTime }, get CalendarIcon() { return CalendarIcon }, get ClockIcon() { return ClockIcon }, get PlayIcon() { return PlayIcon }, get UserIcon() { return UserIcon } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})